import urls from '../constants/urls'

export const LOAD_WHITELISTED_USERS_FAILED = 'whitelistedUsers/LOAD_FAILED'
export const LOAD_WHITELISTED_USERS_SUCCESS = 'whitelistedUsers/LOAD_SUCCESS'
export const LOADING_WHITELISTED_USERS = 'whitelistedUsers/LOADING'

export const PROMOTE_USER_TO_ADMIN_FAILED = 'whitelistedUsers/PROMOTE_USER_TO_ADMIN_FAILED'
export const PROMOTE_USER_TO_ADMIN_SUCCESS = 'whitelistedUsers/PROMOTE_USER_TO_ADMIN_SUCCESS'
export const PROMOTING_USER_TO_ADMIN = 'whitelistedUsers/PROMOTING_USER_TO_ADMIN'

const initialState = {
  whitelistedUsers: [],

  isLoading: false,
  hasLoaded: false,
  failedLoading: false,

  isPromoting: false,
  hasPromoted: false,
  failedPromoting: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_WHITELISTED_USERS:
      return {
        ...state,
        isLoading:     true,
        failedLoading: false
      }

    case LOAD_WHITELISTED_USERS_SUCCESS:
      return {
        ...state,
        whitelistedUsers: action.payload.data,
        page:             action.payload.headers['x-page'],
        pages:            action.payload.headers['x-pages'],
        total:            action.payload.headers['x-total'],
        isLoading:        false,
        failedLoading:    false,
        hasLoaded:        true
      }

    case LOAD_WHITELISTED_USERS_FAILED:
      return {
        ...state,
        isLoading:     false,
        failedLoading: true
      }

    case PROMOTING_USER_TO_ADMIN:
      return {
        ...state,
        isPromoting:     true,
        failedPromoting: false
      }

    case PROMOTE_USER_TO_ADMIN_SUCCESS:
      const newWhitelistedUsers =
        state.whitelistedUsers.map(function(whitelistedUser) {
          if (whitelistedUser.user_id === action.payload.data['id']) {
            whitelistedUser.can_admin = true
          }
          return whitelistedUser
        })

      return {
        ...state,
        isPromoting: false,
        hasPromoted: true,
        whitelistedUsers: newWhitelistedUsers
      }

    case PROMOTE_USER_TO_ADMIN_FAILED:
      return {
        ...state,
        isPromoting: false,
        failedPromoting: true
      }

    default:
      return state
  }
}

export const loadWhitelistedUsers = (hospital, page, searchTerm) => (dispatch) => {
  return dispatch({
    types:   [LOADING_WHITELISTED_USERS, LOAD_WHITELISTED_USERS_SUCCESS, LOAD_WHITELISTED_USERS_FAILED],
    payload: {
      request: {
        url:    urls.hospitals.whitelistedUsers.index(hospital.id),
        params: { page, search_string: searchTerm }
      }
    }
  })
}

export const promoteUserToAdmin = (userId, hospitalId) => (dispatch) => {
  return dispatch({
    types:   [
      PROMOTING_USER_TO_ADMIN,
      PROMOTE_USER_TO_ADMIN_SUCCESS,
      PROMOTE_USER_TO_ADMIN_FAILED
    ],
    payload: {
      request: {
        method: 'post',
        url: urls.users.hospitals.promote_to_admin.create(userId, hospitalId)
      }
    }
  })
}
